import { Box } from "@mui/material";
import { brown } from "@mui/material/colors";
import React from "react";

import { styled, alpha } from "@mui/material/styles";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { TreeItem, treeItemClasses } from "@mui/x-tree-view/TreeItem";
import InitVars from "../../src/InitVars";

const SidebarTribeMember = React.memo(() => {
  const CustomTreeItem = styled(TreeItem)(({ theme }) => ({
    color: brown[100],
    [`& .${treeItemClasses.content}`]: {
      borderRadius: theme.spacing(0.5),
      padding: theme.spacing(0.5, 1),
      margin: theme.spacing(0.2, 0),
      [`& .${treeItemClasses.label}`]: {
        fontSize: "0.8rem",
        fontWeight: 500,
      },
    },
    [`& .${treeItemClasses.iconContainer}`]: {
      borderRadius: "50%",
      backgroundColor: theme.palette.primary.dark,
      padding: theme.spacing(0, 1.2),
      ...theme.applyStyles("light", {
        backgroundColor: alpha(theme.palette.primary.main, 0.25),
      }),
      ...theme.applyStyles("dark", {
        color: theme.palette.primary.contrastText,
      }),
    },
    [`& .${treeItemClasses.groupTransition}`]: {
      marginLeft: 10,
      paddingLeft: 5,
      borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
    },
    ...theme.applyStyles("light", {}),
  }));

  const CustomTreeItemGroupHeader = styled(TreeItem)(({ theme }) => ({
    color: brown[400],
    [`& .${treeItemClasses.content}`]: {
      borderRadius: theme.spacing(0.5),
      padding: theme.spacing(0.5, 1),
      margin: theme.spacing(0.2, 0),
      [`& .${treeItemClasses.label}`]: {
        fontSize: "0.8rem",
        fontWeight: 500,
      },
    },
    [`& .${treeItemClasses.iconContainer}`]: {
      borderRadius: "50%",
      backgroundColor: theme.palette.primary.dark,
      padding: theme.spacing(0, 1.2),
      ...theme.applyStyles("light", {
        backgroundColor: alpha(theme.palette.primary.main, 0.25),
      }),
      ...theme.applyStyles("dark", {
        color: theme.palette.primary.contrastText,
      }),
    },
    [`& .${treeItemClasses.groupTransition}`]: {
      marginLeft: 10,
      paddingLeft: 5,
      borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
    },
    ...theme.applyStyles("light", {}),
  }));

  const [expandedItems, setExpandedItems] = React.useState<string[]>([
    "member",
    "buildertools",
    "guides",
  ]);

  const handleExpandedItemsChange = (
    event: React.SyntheticEvent,
    itemIds: string[]
  ) => {
    setExpandedItems(itemIds);
  };

  function handleTreeNodeClick(e: HTMLLIElement, nodeText: string) {
    InitVars.sidebarOption = nodeText;
  }

  return (
    <div className="sidebar">
      <Box
        sx={{
          height: "94vh",
          borderRight: 1,
          borderColor: brown[900],
          paddingLeft: 1,
        }}
      >
        <SimpleTreeView
          expandedItems={expandedItems}
          onExpandedItemsChange={handleExpandedItemsChange}
        >
          <CustomTreeItemGroupHeader itemId="member" label="Member">
            {/* <CustomTreeItem
              itemId="grid-community"
              label="@mui/x-data-grid"
              onClick={(e) => (InitVars.sidebarOption = "")}
            />
            <CustomTreeItem
              itemId="grid-pro"
              label="@mui/x-data-grid-pro"
              onClick={(e) => (InitVars.sidebarOption = "")}
            /> */}
            <CustomTreeItem
              itemId="tribememberoptions"
              label="Tribe member option"
              onClick={(e) => (InitVars.sidebarOption = "TribeMemberOptions")}
            />
          </CustomTreeItemGroupHeader>
          <CustomTreeItemGroupHeader
            itemId="guides"
            label="Guides"
            onClick={(e) => (InitVars.sidebarOption = "")}
          >
            <CustomTreeItem
              itemId="guidescomingsoon"
              label="Coming Soon!"
              onClick={(e) => (InitVars.sidebarOption = "")}
            />
          </CustomTreeItemGroupHeader>
          <CustomTreeItemGroupHeader
            itemId="buildertools"
            label="Builder Tools"
            onClick={(e) => (InitVars.sidebarOption = "")}
          >
            <CustomTreeItem
              itemId="buildersmartgates"
              label="Smart Gates"
              onClick={(e) => (InitVars.sidebarOption = "BuilderSmartGates")}
            />
            <CustomTreeItem
              itemId="buildersmartstorageunits"
              label="Smart Storage Units"
              onClick={(e) =>
                (InitVars.sidebarOption = "BuilderSmartStorageUnits")
              }
            />
            <CustomTreeItem
              itemId="buildersmartturrets"
              label="Smart Turrets"
              onClick={(e) => (InitVars.sidebarOption = "BuilderSmartTurrets")}
            />
          </CustomTreeItemGroupHeader>
          {/* <CustomTreeItemGroupHeader
            itemId="tree-view"
            label="Tree View"
            onClick={(e) => (InitVars.sidebarOption = "")}
          >
            <CustomTreeItem
              itemId="tree-view-community"
              label="@mui/x-tree-view"
              onClick={(e) => (InitVars.sidebarOption = "")}
            />
          </CustomTreeItemGroupHeader> */}
        </SimpleTreeView>
      </Box>
    </div>
  );
});

export default React.memo(SidebarTribeMember);
